import { render, staticRenderFns } from "./JSelectXueqi.vue?vue&type=template&id=031c556c&scoped=true"
import script from "./JSelectXueqi.vue?vue&type=script&lang=js"
export * from "./JSelectXueqi.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "031c556c",
  null
  
)

export default component.exports